export const env = (() => {
    const {
        href = ''
    } = location
    const isProd = /\.com/.test(href)
    const isTest = /\.cn/.test(href)
    const isDev = !isProd && !isTest

    return {
        isProd,
        isTest,
        isDev,
    }
})()



// WEBPACK FOOTER //
// ./src/methods/env.js